module.exports = __webpack_public_path__ + "assets/img/side-navigation-activity-rules-active-26d4f499.png";